/* eslint-disable max-len */
import React, {useCallback, useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {RealTime, RouteModel, StopModel, Itinerary} from '../../core/models';
import {DataContext} from '../../services/data-v2/data.context';

import './real-times.scss';

export const RealTimesComponent = ({
    stop,
    route,
    itinerary,
}: { stop: StopModel, route: RouteModel, itinerary?: Itinerary }) => {

    const {t} = useTranslation();

    const {realTimes} = useContext(DataContext);

    const [rt, setRt] = useState<RealTime[]>([]);
    const [next, setNext] = useState<Date[]>();

    const realTimesHandler = useCallback(() => {
        const rt = realTimes[stop.id]?.realTimes[route.id] || [];
        // setRt(rt.filter((t) => itinerary ? t.destination === itinerary.trips_headsign : true));
        // setRt(rt);
        setRt(route.slug === 'renfe' ? rt.filter((t) => itinerary ? t.destination === itinerary.trips_headsign : true) : rt);
    }, [stop, route, realTimes]);

    useEffect(() => {
        realTimesHandler();
    }, [realTimes]);

    useEffect(() => {
        if (itinerary) {
            const stt = itinerary.services_timetables.find((stt) => stt.todayService);
            if (stt) {
                const times = stt.timetable.map((time) => {
                    const arr = time.split(':').map((n: string) => parseInt(n));
                    const date = new Date();
                    date.setHours(arr[0], arr[1], 0, 0);

                    return date;
                });

                const next = times.reduce((current, next, index, arr) => Date.now() > current[0].getTime() ? [next, arr[index + 1] || arr[0]] : current, [times[0], times[1]]).filter((t) => !!t);

                setNext(next);
            }
        }
    }, [itinerary]);

    return <div className="real-times-container">
        {
            !!rt.length && rt[0].arrivalTime <= 3600 && <div className="real-times">
                <div className="label">{t('translation:web_stop_bus_time')}</div>
                <div className="times">
                    {
                        rt.slice(0, 2).map((realTime, key) => {

                            const minutes = Math.round(realTime.arrivalTime / 60);
                            // const seconds = realTime.arrivalTime % 60;
                            return <div key={key} className="time">
                                {key > 0 && <div className="separator">·</div>}
                                <div>{minutes > 0 ? minutes : t('translation:transport_marker_detail_real_times_now_text')}</div>
                                <div className="units">{minutes > 0 ? 'min' : ''}</div>
                            </div>;
                        })
                    }
                </div>
            </div>
        }
        {
            (!rt.length || rt[0].arrivalTime > 3600) && <div className='time-tables'>
                <span>{next ? <div className="label">{t('translation:public_transport_programmed')}</div> :
                    <div className="label">{t('translation:transport_marker_detail_real_times_not_available')}</div>}</span>
                <div className="times">
                    {next?.map((time: any, key) => {
                        return <div key={key} className="time">
                            {key > 0 && <div className="separator">· </div>}
                            {time?.getHours() == 0 ? '0' + time?.getHours() : time?.getHours()}:{time?.getMinutes() < 10 ? '0' + time?.getMinutes() + 'h' : time?.getMinutes() + 'h'}
                        </div>;
                    })}
                </div>
            </div>
        }
    </div>;
};
